/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.BuyingRpc
 */

/**
 *  Request model for purchasing products and quantity packs.
 *  <p><b>Products:</b> Use {@code products} for parent/bundle products (e.g., "marketing-hub-starter").
 *  <p><b>Quantity Packs:</b> Use {@code quantityPacks} with {@link RequestedQuantity}
 *  <pre>{@code
 *  PurchaseRequest request = PurchaseRequest.builder()
 *    .setQuantityPacks(ImmutableSet.of(
 *      RequestedQuantity.builder()
 *        .setQuantityName(WireSafeEnum.of(QuantityName.CONTACTS))
 *        .setTotalQuantity(10)
 *        .setParentProductApiName("marketing-hub-starter")
 *        .build()
 *    ))
 *    .build();
 *  }</pre>
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const createPurchaseOrderRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'createPurchaseOrder',
  auth: 'app',
  fingerprint: '_XCnKSsip0TY5pstqgNqILbwF4hDbpl5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSeatsProductInventoryRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'getSeatsProductInventory',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACHTP33O5UJ5JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInterstitialRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'getInterstitial',
  auth: 'app',
  fingerprint: '_XCnKSsip0RV5ax64dYKApwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};